import * as ProductActions from "./productActions";

export default ProductActions;
